'use client';

import { ConfigProvider } from 'antd';

const antdTheme = {
   token: {
      colorPrimary: '#3366FF',
      colorInfo: '#3366FF',
      colorSuccess: '#52BD94',
      colorWarning: '#FFB020',
      colorError: '#D14343',
      colorTextBase: '#101840',
      borderRadius: 8,
      fontFamily: 'Inter, sans-serif',
   },
};

export default function AntdThemeProvider({ children }) {
   return <ConfigProvider theme={antdTheme}>{children}</ConfigProvider>;
}
